export const MAX_CHIPS_COUNT = 3
